import { SOCKET_URL } from "helpers/constants/urls";

export const connectChatSocket = (userId, sessionId) => {
  const ws = new WebSocket(`${SOCKET_URL}/ws/chat/${userId}/${sessionId}/`);
  console.log(
    `${SOCKET_URL}/ws/chat/${userId}/${sessionId}/`,
    "----------->>>>>>>>>>>>>"
  );
  ws.onopen = () => {
    console.info("opened");
  };
  ws.onmessage = (e) => {
    // a message was received
    console.log(e.data);
  };
  ws.addEventListener("message", (event) => {
    console.log("message", event.data);
  });
  ws.onerror = (e) => {
    // an error occurred
    console.error(e);
  };
  ws.onclose = (e) => {
    // connection closed
    console.error(e.code, e.reason);
  };
  return ws;
};
